// @flow

import React, { type Node } from 'react';
import {
  getCountry,
  getSafeDueDate,
  usePendingIncomingPayment,
} from '@tectonics/prs/incoming-payment';
import { formatDueDate } from '@tectonics/prs/cash-mexico';
import { PaymentInfo } from '../payment-info';
import styled from 'styled-components';
import { getWeekDayByCountry } from '@tectonics/prs/week-day';

export function DisplayEfectyDueDate(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const country = getCountry(incomingPayment);
  const dueDate = getSafeDueDate(incomingPayment);

  if(incomingPayment.status !== 'PE')
    throw new Error(`Paynet: invalid payment status ${incomingPayment.status}, it should be PE`);

  return (
    <PaymentInfo label="Fecha de Vencimiento">
      {formatDueDate(dueDate)}
      <DueWeekDay>(Paga hasta el {getWeekDayByCountry(dueDate, country)})</DueWeekDay>
    </PaymentInfo>
  );
}

const DueWeekDay = styled.span`
    display: block;
    font-size: 14px;
`;
